<template>
  <div class="register-box">
    <div class="logo-header">
      <div class="header-img"></div>
      <div>天艺空间</div>
    </div>

    <div class="register-form-box">
      <div class="input-item-box">
        <input type="text" class="input-item" v-model="registerObj.phone" placeholder="请输入手机号" />
      </div>

      <div class="input-item-box">
        <input type="text" class="input-item" v-model="registerObj.imgCode" placeholder="请输入图形验证码" />
        <canvas id="canvas" width="200" height="80" @click="handleClick"></canvas>
      </div>

<!--      <div class="input-item-box">-->
<!--        <input type="text" class="input-item" v-model="registerObj.code" placeholder="请输入验证码" />-->
<!--        <button class="getCode" @click="getCodeHandle">{{ getCodeTxt }}</button>-->
<!--      </div>-->

      <div class="input-item-box">
        <input type="password" class="input-item" v-model="registerObj.password" placeholder="请输入6-20位密码" />
      </div>

      <div class="input-item-box">
        <input type="password" class="input-item" v-model="registerObj.repassword" placeholder="请再次输入密码" />
      </div>

      <div class="input-item-box">
        <input type="text" class="input-item" v-model="registerObj.intv" placeholder="请输入邀请码" />
      </div>
    </div>

    <div class="agree-box">
      <p class="error-info">{{ errorMsg }}</p>

      <div class="show-info">
        <van-checkbox class="ready-read" v-model="registerObj.radio" shape="square" icon-size="3.2rem">我已阅读并同意
          <router-link class="color_959AB5" to="userInfo" tag="a">《用户协议》</router-link>、<router-link to="yszc" tag="a"
            class="color_959AB5">《隐私政策》</router-link>
        </van-checkbox>
      </div>
      <div class="mt—10">
        <button class="register-btn" @click="registerHandle">注册</button>
      </div>
    </div>

    <div class="has-register">
      <p>
        已有账号,
        <router-link to="downApp" tag="span" class="down-now">立即下载</router-link>
      </p>
    </div>

    <!-- Toast 提示 -->
    <div v-show="msgShow" class="toast-wrp">
      <div class="toast-content">
        <div class="toast-title">温馨提示</div>
        <div class="toast-subtitle">{{ errorMsg }}</div>
        <div class="confirm-btn" @click="msgShow = false">我知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import ImageVerify from "../image-verify.js";
export default {
  data() {
    return {
      msgShow: false,
      registerObj: {
        imgCode: "",
        phone: "",
        radio: false,
        imageVerify: '',
        intv: "",
        repassword: "",
        password: "",
        code: "",
        phoneCodeId: "",
      },
      errorMsg: "",
      getCodeTxt: "获取验证码",
    };
  },
  mounted() {
    this.registerObj.intv = (this.$route.query && this.$route.query.code) || this.registerObj.intv;
    this.imageVerify = new ImageVerify({ id: 'canvas', width: 200, height: 80, }) || '';

    const ua = navigator.userAgent;
    const iOS = /iPad|iPhone|iPod/.test(ua);
    const inputs = document.querySelectorAll('input');
    inputs.forEach(input => {
      input.addEventListener('focus', () => {
        setTimeout(() => {
          if (iOS) {
            if (!/OS 11_[0-3]\D/.test(ua)) {
              document.body.scrollTop = document.body.scrollHeight;
            }
          } else {
            for (let i = 0; i < inputs.length; i++) {
              inputs[i].scrollIntoView(false);
            }
          }
        }, 300);
      });
    });

  },
  methods: {
    handleClick() {
      this.imageVerify.start();
      console.log(this.imageVerify.code);
    },
    async getCodeHandle() {
      let vertifyCode = this.registerObj.imgCode ? this.registerObj.imgCode.toUpperCase() : '';
      if (vertifyCode != this.imageVerify.code.toUpperCase()) {
        this.errorMsg = "请输入正确的图形验证码";
        this.showToast(this.errorMsg);
        return;
      }
      if (this.getCodeTxt !== "获取验证码") {
        return;
      }
      if (this.registerObj.phone.trim() === "") {
        this.errorMsg = "请输入手机号";
        this.showToast(this.errorMsg);
        return;
      }
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.registerObj.phone)) {
        this.errorMsg = "手机号格式有误";
        this.showToast(this.errorMsg);
        return;
      }

      try {
        let { data } = await this.axios.post(
          "/startNFT/api/user/util/sendValidateCode",
          {
            phone: this.registerObj.phone,
          }
        );
        this.errorMsg = data && data.msg;

        if (data.code == 200) {
          this.registerObj.phoneCodeId = data.data.phoneCodeId;
          let time = 60;
          this.timer && clearInterval(this.timer);
          this.timer = setInterval(() => {
            if (time > 0) {
              this.getCodeTxt = --time + "s";
            } else {
              this.getCodeTxt = "获取验证码";
            }
          }, 1000);
        }
      } catch (error) {
        this.errorMsg = "服务器繁忙，请稍后再试！！";
        this.showToast(this.errorMsg);
      }
    },
    async registerHandle() {
      if (this.registerObj.phone.trim() === "") {
        this.errorMsg = "请输入手机号";
        this.showToast(this.errorMsg);
        return;
      }

      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.registerObj.phone)) {
        this.errorMsg = "手机号格式有误";
        this.showToast(this.errorMsg);
        return;
      }

      // if (this.registerObj.code.trim() === "") {
      //   this.errorMsg = "请输入验证码";
      //   this.showToast(this.errorMsg);
      //   return;
      // }

      if (
        this.registerObj.password.length < 6 ||
        this.registerObj.password.length > 20
      ) {
        this.errorMsg = "请输入6-20位密码";
        this.showToast(this.errorMsg);
        return;
      }

      if (this.registerObj.repassword !== this.registerObj.password) {
        this.errorMsg = "两次密码不一致";
        this.showToast(this.errorMsg);
        return;
      }

      if (this.registerObj.intv.trim() === "") {
        this.errorMsg = "邀请码为空";
        this.showToast(this.errorMsg);
        return;
      }

      if (!this.registerObj.radio) {
        this.errorMsg = "请同意用户协议及隐私政策";
        this.showToast(this.errorMsg);
        return;
      }

      this.errorMsg = "";
      // const Sign = md5(
      //   `code=${123456}&password=${this.registerObj.password}&phone=${this.registerObj.phone}&phoneCodeId=${this.registerObj.phoneCodeId}&usrCode=${this.registerObj.intv}&key=3e798520504140431e329f7c59cd79fb`
      // );
      const Sign = md5(
        `password=${this.registerObj.password}&phone=${this.registerObj.phone}&phoneCodeId=${this.registerObj.phoneCodeId}&usrCode=${this.registerObj.intv}&key=3e798520504140431e329f7c59cd79fb`
      );
      let { data } = await this.axios.post(
        "/startNFT/api/user/userInfo/register",
        {
          phone: this.registerObj.phone,
          phoneCodeId: this.registerObj.phoneCodeId,
          // code: this.registerObj.code,
          password: this.registerObj.password,
          usrCode: this.registerObj.intv,
        },
        {
          headers: {
            sign: Sign,
          },
        }
      );
      if (data.code == 200) {
        this.$router.push({
          path: "DownApp",
        });
      } else {
        this.errorMsg = data.msg;
      }
    },
    // 展示Toast
    showToast() {
      this.msgShow = true;
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.toast-wrp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.toast-content {
  position: relative;
  width: 89.3vw;
  min-height: 40vw;
  background: #0B1225;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding-bottom: 17.4vw;
  background-image: url('../assets/group-back.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.toast-title {
  font-size: 4.3vw;
  color: #FFFFFF;
  line-height: 5.1vw;
  margin-top: 6.9vw;
}

.toast-subtitle {
  margin: 11.1vw 0 5.3vw 0;
  font-size: 3.7vw;
  color: #899CC2;
}

.confirm-btn {
  position: absolute;
  bottom: 6.5vw;
  width: 38.7vw;
  left: 50%;
  transform: translateX(-50%);
  height: 10.7vw;
  background: linear-gradient(90deg, #0FFFFC 0%, #A378FF 100%);
  font-size: 4.3vw;
  color: #000000;
  line-height: 10.7vw;
  font-weight: bold;
  text-align: center;
  border-radius: 5.3vw 5.3vw 5.3vw 5.3vw;
}

.register-box {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #030D17;
  overflow-x: hidden;
  box-sizing: border-box;
}

.logo-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 8rem;
  font-size: 5.6vw;
}

.header-img {
  width: 34.7vw;
  height: 24.9vw;
  background: url("../assets/logo.jpg") no-repeat center;
  background-size: contain;
  margin-top: 14vw;
  margin-bottom: 5.5vw;
}


.register-form-box {
  margin: 10.6vw 4vw 0 4vw;
  box-sizing: border-box;
  /* padding: 7vw 2.3rem 7vw 0; */
  background: #0B1225;
  border-radius: 1rem;

}

.input-item-box {
  margin: 2rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.input-item {
  height: 10.9rem;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #000b20;
  box-sizing: border-box;
  padding-left: 1.4rem;
  font-size: 4.3vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #f3ffff;
}

input {
  background: none;
  outline: none;
  caret-color: #FFF;
}

.input-item::placeholder {
  font-size: 4.3vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #899CC2;
  caret-color: #fff;
}

.passwd-img {
  width: 3.1vw;
  height: 2vw;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.getCode {
  padding: 1.5vw 3vw;
  background: #0FFFFC;
  border-radius: 4vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3.7vw;
  font-weight: bold;
  color: #000000;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  border: 0;
}

::v-deep .van-checkbox__label {
  color: #55617A !important;
  font-size: 3.5vw;
}

::v-deep .van-checkbox__icon--checked .van-icon {
  background-color: #0FFFFC;
  border-color: #0FFFFC;
}

::v-deep .van-toast {
  font-size: 3.5vw;
}

.show-info {
  height: 3.6rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 2.1vw;
}

.ready-read {
  font-size: 2.4rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #55617A !important;
}

.color_959AB5 {
  font-size: 3.5vw;
  color: #55617A;
}

.mt—10 {
  margin-top: 1.1rem;
  margin: 2.1rem 2.3rem 0 2.3rem;
}

.error-info {
  margin-left: 2vw;
  font-size: 3.7vw;
  padding: 1vw 0 2vw 0;
  color: #fc6682;
}

.register-btn {
  display: block;
  margin-left: 50%;
  width: calc(100vw - 5.4vw);
  transform: translateX(-50%);
  height: 11.7vw;
  font-size: 4.8vw;
  color: #000000;
  font-weight: bold;
  margin-top: 8vw;
  background: linear-gradient(90deg, #0FFFFC 0%, #A378FF 100%);
  border-radius: 1.1vw;
}

.has-register {
  margin-top: 3rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 5rem;
}

.has-register p {
  font-size: 3.7vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin-right: 5rem;
  margin-top: 2vw;
}

.down-now {
  color: #0FFFFC;
  border-bottom: .4vw solid #0FFFFC;
  padding-bottom: 1vw;
}

.agree-box {
  margin: 1vw 4vw 0 4vw;
}
</style>
